<template>
  <ValidationProvider tag="div" :rules="rules" :name="name" :vid="vid" v-slot="{ errors }" :mode="mode">
    <input
      :type="type"
      v-model="inner.value"
      ref="input"
      :class="[
        inputClass,
        {
          'is-invalid': errors.length,
        },
      ]"
      v-debounce:300ms="onDebounce"
    />
    <template v-if="errors">
      <b-tooltip
        v-if="errorMode == 'tooltip'"
        :target="() => $refs['input']"
        :title="errors.length ? errors[0] : null"
        variant="danger"
        noninteractive
        placement="top"
        boundary="window"
      ></b-tooltip>
      <div v-else class="text-danger">
        {{ errors[0] }}
      </div>
    </template>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { BTooltip } from "bootstrap-vue";

export default {
  name: "InputTime",
  components: {
    ValidationProvider,
    BTooltip,
  },
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    rules: {
      type: [String, Object],
      default: "",
    },
    name: {
      type: String,
      default: undefined,
    },
    vid: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: "text",
    },
    mode: {
      type: String,
      default: "eager",
    },
    inputClass: {
      type: String,
      default: "form-control form-control-sm",
    },
    errorMode: {
      type: String,
      default: "normal",
    },
  },
  data() {
    return {
      inner: {
        value: this.value,
        old: this.value
      },
    };
  },
  watch: {
    "inner.value"(val, old) {
      // this.$emit("input", val);

      this.inner.old = old;

      // console.log({ val, old });

      let innerVal = String(val);
      let innerOld = String(old);

      if (innerVal.length < innerOld.length) return this.$emit("input", this.inner.value);

      if (innerVal.includes(":")) return this.$emit("input", this.inner.value);

      if (innerVal.length == 3 && innerOld.length == 2 && !innerOld.includes(':')) {
        this.inner.value = `${innerOld}:${innerVal.substr(-1,1)}`
      }

      this.$emit("input", this.inner.value);
    },
    value(val) {
      this.inner.value = val;
    },
  },
  methods: {
    onDebounce(val) {

      console.log("debounce", {val});
      console.log("debounce", {old: this.inner.old});

      if (val.length < this.inner.old.length) return;


      if (val.length === 4 && val.includes(":")) {
        let split = val.split(":");

        if (split[0].length < 2) return;

        this.inner.value = `${split[0][0]}:${split[0][1]}${split[1]}`;
      }

      if (val.length === 5 && val.includes(":")) {
        let split = val.split(":");

        if (split[1].length < 3) return;

        this.inner.value = `${split[0][0]}${split[1][0]}:${split[1][1]}${split[1][2]}`;
      }

      

    }
  }
};
</script>
